import { PropsWithChildren } from 'react';
import styled, { css } from 'styled-components';
import colors from '../../helpers/colors';

const CHEVRON_TRIANGLE_WIDTH_TO_HEIGHT_RATIO = 0.065826; // truncation of (tan 7.5deg) / 2

const whiteRectangleStyles = css`
  content: ' ';
  position: absolute;
  top: 100%;
  left: -50%;
  right: -50%;
  height: 50vw;
  background: ${colors.neutral08};
`;

const ChevronBackground = styled.div<PropsWithChildren>`
  background: ${({ theme }) => theme.gradients.gradient01.to};
  margin: 0 calc(50% - 50vw);
  padding: 0 calc(50vw - 50%);

  display: flex;
  justify-content: center;
  position: relative;
  overflow: hidden;

  &::before {
    ${whiteRectangleStyles}
    transform: rotate(7.5deg);
    transform-origin: top center;
  }
  &::after {
    ${whiteRectangleStyles}
    transform: rotate(-7.5deg);
    transform-origin: top center;
  }

  /* This padding covers the bottom triangle in the chevron.
    This allows us to easily enforce the spacing between the content and the triangle.
    
    Usually the spacing between the content and triangle is calculated from the corner of 
    the full triangle. But when screen width > 1440px, we calculate this spacing from the
    the subtriangle that has width 1440px.
   */
  padding-bottom: calc(100vw * ${CHEVRON_TRIANGLE_WIDTH_TO_HEIGHT_RATIO});
  @media (min-width: 1440px) {
    padding-bottom: calc(1440px * ${CHEVRON_TRIANGLE_WIDTH_TO_HEIGHT_RATIO});
  }
`;

export default ChevronBackground;
